import { Component, ViewEncapsulation, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterOutlet } from '@angular/router';
import { RickService } from '../service/rick.service';

@Component({
  selector: 'app-cases-used',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule, MatButtonModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatInputModule],
  templateUrl: './cases-used.component.html',
  styleUrl: './cases-used.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [RickService]
})
export class CasesUsedComponent {
  @ViewChild('notificationMessageDiv') errorDiv!: ElementRef;
  @ViewChild('successMessageDiv') successDiv!: ElementRef;
  casesAddForm: FormGroup = new FormGroup({});
  submitted: boolean = false;
  isSaved: boolean = false;
  constructor(private fb: FormBuilder, private router: Router, private rickService: RickService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.casesAddForm = this.fb.group({
      customer: ['', Validators.required],
      state: ['', Validators.required],
      store: ['', Validators.required],
      purchaseOrder: ['', Validators.required],
      caseNumbersSet: [[], [Validators.required, this.tagValidator()]]
    });
  }

  tagValidator(): ValidatorFn {
    return (control: AbstractControl):
      ValidationErrors | null => {
      const numberRegex = /^[0-9]+$/;
      let invalidNumber = false;
      let invalidLength = false;
      control.value.map((value: any) => {
        if (!numberRegex.test(value)) {
          invalidNumber = true;
        } else if (value.length != 7) {
          invalidLength = true;
        }
      })
      return invalidNumber ? { invalidNumber: true }
        : (invalidLength ? { invalidLength: true } : null);
    }
  };

  get caseNumbers(): any {
    return this.casesAddForm.get('caseNumbersSet');
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our case-number
    if ((value || '').trim()) {
      this.caseNumbers.setValue([...this.caseNumbers.value, value.trim()]);
      this.caseNumbers.updateValueAndValidity();
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(number: string): void {
    const index = this.caseNumbers.value.indexOf(number);

    if (index >= 0) {
      this.caseNumbers.value.splice(index, 1);
      this.caseNumbers.updateValueAndValidity();
    }
  }

  addCaseNumbers() {
    console.log('form is', this.casesAddForm.value);
    this.submitted = true;
    if (this.casesAddForm.valid) {
      let postData = {
        "purchaseOrderDto": {
          "edpNumberDto": {
          "customer": this.casesAddForm.controls.customer.value,
          "state": this.casesAddForm.controls.state.value,
          "store": this.casesAddForm.controls.store.value
          },
          "poNumber": this.casesAddForm.controls.purchaseOrder.value
        },
        "caseNumbersSet": this.casesAddForm.controls.caseNumbersSet.value
      }
      this.rickService.addCasesUsed(postData).subscribe((res) => {
        this.isSaved = true;
        this.changeDetectorRef.detectChanges();
        this.errorDiv.nativeElement.scrollIntoView();
      }, (error) => {
        this.casesAddForm?.setErrors({ invalid: error?.error?.errorMessages[0] });
        this.changeDetectorRef.detectChanges();
        this.errorDiv.nativeElement.scrollIntoView();
      });
    }
  }

  cancelPage() {
    this.router.navigate(['/home']);
  }
}
